import Input from 'components/common/form/input/Input';
import React from 'react';
import { Col, FormGroup, FormLabel, Row } from 'react-bootstrap';

function CandidateExperienceForm() {
  return (
    <Row>
      <Col xs={12}>
        <p>
          The <strong>Years of Experience</strong> field captures the total
          duration an individual has spent working in a particular role or
          industry. If you don’t have any experience, you can either type{' '}
          <code>0</code> or leave the field blank. This helps provide an
          accurate representation of your professional background.
        </p>
      </Col>
      <Col xs={12} xl={4}>
        <FormGroup className="text-start">
          <FormLabel htmlFor="yearsOfExperience">Years of experience</FormLabel>
          <Input name="yearsOfExperience" id="yearsOfExperience" />
        </FormGroup>
      </Col>
    </Row>
  );
}

export default CandidateExperienceForm;
